import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalService } from '../global.service';
import * as M from "materialize-css/dist/js/materialize";

@Component({
	selector: 'pregled-automobila',
	templateUrl: './pregled-automobila.component.html',
	styleUrls: ['./pregled-automobila.component.css']
})
export class PregledAutomobilaComponent implements OnInit {
	@Input() idVlasnika;
	@Input() nazivLica;

	@Output() onCancel = new EventEmitter<any>();

	constructor(private http: HttpClient, public globalSrvc: GlobalService) { }
	ngOnInit() {
		this.ucitaj();
	}

	server_data : any = null;
	loading = false;
	msg : any;
	automobili : any = [];
	currentView = 'main';
	odabranoVoziloId : any = null; 
	odabraniProizvodjac : any = null; 
	odabraniRegBroj : any = null;
	odabraniPregledId : any = null;
	filterAuto = '';
	nazivProizvodjaca : any = null;
	regBroj : any  = null; 
	idAuta : any = null; 

	ucitaj() {

		this.loading = true;
		this.http.get('vlasnici/automobili', { params: { idVlasnika: this.idVlasnika } })
			.subscribe(data => {
				this.loading = false;
				this.automobili = data;
				
				/*setTimeout(() => {
					M.updateTextFields();
				}, 300);*/
				
				//this.ucitajSkole();
			}
			, error => {
				this.loading = false;
			});
	}

	onInsertPregled(data){
		this.currentView = 'main';
	}

	cancel(){
		//console.log(this.onCancel);
		if (this.onCancel)
			this.onCancel.emit(null);
	}

	onCancelVozilo(data){
		this.currentView = 'main';
	}

	onCancelPregled(data){
		this.currentView = 'main';
	}

	dodajVozilo(){
		this.odabranoVoziloId = null;
		this.currentView = 'vozilo';
	}

	dodajPregled(auto){
		this.regBroj = auto.registracija; 
		this.nazivProizvodjaca = auto.nazivMarka;
		this.idAuta = auto.id;
		this.currentView = 'pregled';		
	}

	izmijeniVozilo(vozilo){
		this.odabranoVoziloId = vozilo.id;
		this.currentView = 'vozilo';
	}

	onInsertVozilo(vozilo){		
		this.currentView = 'main';

		if (this.odabranoVoziloId){
			let index = this.automobili.findIndex((item) => item.id == this.odabranoVoziloId);
			if (index >= 0)
				this.automobili[index] = vozilo;
		}
		else
			this.automobili.unshift(vozilo);

		this.odabranoVoziloId = null;
	}

	pregledi(vozilo){
		this.odabranoVoziloId = vozilo.id;
		this.odabraniProizvodjac = vozilo.nazivMarka;
		this.odabraniRegBroj = vozilo.registracija;
		this.currentView = 'pregledi';
	}

}
